/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonQueryResponse,
  GetApiV1PersonQueryParams,
  GetApiV1Person401,
  GetApiV1Person500,
} from "../../types/personRegisterController/GetApiV1Person.ts";

function getGetApiV1PersonUrl() {
  const res = { method: "GET", url: `/api/v1/person` as const };
  return res;
}

/**
 * @description Retorna uma lista paginada de pessoas com filtros opcionais. **(Requer Authorization para autenticação)**
 * @summary Listar pessoas (Requer Authorization para autenticação)
 * {@link /api/v1/person}
 */
export async function getApiV1Person(
  params?: GetApiV1PersonQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonQueryResponse,
    ResponseErrorConfig<GetApiV1Person401 | GetApiV1Person500>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
